import { render, staticRenderFns } from "./CreateProjectsFromPrm.vue?vue&type=template&id=2687f125"
import script from "./CreateProjectsFromPrm.vue?vue&type=script&lang=js"
export * from "./CreateProjectsFromPrm.vue?vue&type=script&lang=js"
import style0 from "./CreateProjectsFromPrm.vue?vue&type=style&index=0&id=2687f125&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports